import { Component, OnInit } from '@angular/core';
import { JobPointeTransferService } from '../job-pointe-transfer.service';

@Component({
  selector: 'app-add-employee-button',
  templateUrl: './add-employee-button.component.html',
  styleUrls: ['./add-employee-button.component.scss'],
})
export class AddEmployeeButtonComponent implements OnInit {
  constructor(private jobPointeTransferService: JobPointeTransferService) { }

  ngOnInit(): void { }

  addEmployee() {
    this.jobPointeTransferService.editEmployeeModalIsOpenSource.next(true);
  }
}
